// Context hooks - replacing Apollo
import { useResult } from "../../../shared/formContext/hooks/useResult";

// Result Types
import Error from "@shared/Error/Error";

// Components
import Empty from "@shared/Empty/Empty";
import { __ } from "@wordpress/i18n";
import React from "react";
import Loading from "../../../components/Loading/Loading";
import RetirementInvestment from "./Result/RetirementInvestment";

/**
 * Results component for retirement investment calculations
 */
const Results: React.FC = () => {
  const { resultData } = useResult();
  const { response, loading, error } = resultData;

  if (loading) {
    return <Loading />;
  }

  if (error) {
    return <Error />;
  }

  if (!response?.data?.result?.data) {
    return <Empty figure={2} />;
  }

  return (
    <div className="tool-block__component__results__result">
      <RetirementInvestment /> 
    </div>
  );
};

export default Results;
